import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "featured-services-card card mb-4 border-radius d-block bg-white border-0 shadow-none" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "trezo-card-content" }
const _hoisted_4 = { class: "p-0 m-0 list-unstyled" }
const _hoisted_5 = { class: "info d-flex align-items-center" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "d-block text-black fw-semibold" }
const _hoisted_8 = { class: "d-block text-body" }
const _hoisted_9 = { class: "number fw-medium text-primary rounded-circle d-flex align-items-center justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-30" }, [
        _createElementVNode("h5", { class: "mb-0" }, "Featured Services")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.services, (service, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: service.id,
              class: "d-flex align-items-center justify-content-between"
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("img", {
                  src: service.icon,
                  alt: service.name
                }, null, 8, _hoisted_6),
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(service.name), 1),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(service.served) + " Served this week ", 1)
                ])
              ]),
              _createElementVNode("span", _hoisted_9, _toDisplayString(index + 1), 1)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}